import gql from "graphql-tag";

export default gql`
{
    highlightFiltered @client
}
`